/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Swal_TitleInputs */



/**
* | output |
* | --- |
* | "Paste Events" |
*
* @param {Paste_Swal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_swal_title = /** @type {((inputs?: Paste_Swal_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Swal_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coller les Evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisse einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incolla eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pegar eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("粘贴事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを貼り付ける")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पेस्ट इवेंट्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Colar eventos")
	return /** @type {LocalizedString} */ ("Paste Events")
});